module.exports = __webpack_public_path__ + "static/media/contact_06.71c48572.jpg";